module.exports = __webpack_public_path__ + "img/foto17.e001c740.jpg";